const { addUrlSearchParams } = require('./add-url-search-params')
const { getGABrand } = require('./get-ga-brand')
const { getGAClientId } = require('./get-ga-client-id')
const { getGAClickId } = require('./get-ga-click-id')
const { getReferer } = require('./get-referer')
const { getUrlSearchParams } = require('./get-url-search-params')
const { isDirectTraffic } = require('./is-direct-traffic')
const { parseTracking } = require('./parse-tracking')
const { removeUrlSearchParams } = require('./remove-url-search-params')
const { setOrgReferer } = require('./set-org-referer')
const { setOrganicTracking } = require('./set-organic-tracking')
const { setTracking } = require('./set-tracking')
const { trackingParams } = require('./tracking-params')

module.exports = {
  addUrlSearchParams,
  getGABrand,
  getGAClientId,
  getGAClickId,
  getReferer,
  getUrlSearchParams,
  isDirectTraffic,
  parseTracking,
  removeUrlSearchParams,
  setOrgReferer,
  setOrganicTracking,
  setTracking,
  trackingParams
}
